import React from "react";
import { Pane, Text } from "evergreen-ui";
import { AddGST, Money } from "../Misc/Money";
export let CartSubtotal = (props) => {
    let setupFees = typeof props.setupFees === "string"
        ? parseFloat(props.setupFees)
        : props.setupFees;
    let jobTotal = typeof props.jobTotal === "string"
        ? parseFloat(props.jobTotal)
        : props.jobTotal;
    return (React.createElement(Pane, { display: "flex", flexDirection: "column", paddingBottom: "20px", alignItems: "end" },
        React.createElement(Text, null,
            React.createElement("h2", null,
                React.createElement("strong", null, "Order Subtotal"))),
        React.createElement(Text, { size: 500 },
            React.createElement("strong", null, "Setup: "),
            React.createElement(Money, null, props.setupFees)),
        React.createElement(Text, { size: 500 },
            React.createElement("strong", null, "Job Total: "),
            " ",
            React.createElement(Money, null, props.jobTotal)),
        React.createElement(Text, { size: 500, marginTop: "0.5em", textAlign: "end" },
            React.createElement("strong", null, "Subtotal: ")),
        React.createElement(Text, { size: 500, textAlign: "end" },
            React.createElement("small", null, "Ex GST "),
            React.createElement(Money, null, jobTotal + setupFees)),
        React.createElement(Text, { size: 500, textAlign: "end" },
            React.createElement("small", null, "Inc GST "),
            React.createElement(Money, null, AddGST(jobTotal + setupFees)))));
};
